/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useMount, useUpdateEffect } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
  Typography,
} from '@mui/material';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box } from '@mui/system';
import MessageModal from '../../components/message/MessageModal';
import {
  getData,
  openModal,
  closeModal,
  transmitMessage,
  deleteMessage,
} from '../../modules/messageBot';
import NewTable from '../../components/NewTable';
import {
  MESSAGE_STATUS_HEADER_DATA,
  MESSAGE_STATUS_VIEW_LIST_LENGTHS,
  MODAL_TYPE_MESSAGE_DELETE,
  MODAL_TYPE_MESSAGE_TRANSMIT,
} from '../../common/consts';
import Toast from '../../components/Toast';

const MessageStatusContainer = () => {
  const dispatch = useDispatch();
  const {
    loading,
    contentItems,
    total,
    list,
    error,
    modal,
    send: { result: sent, message: sendMessage },
    delete: { result: delResult, message: delMessage },
    transmit: { result: transResult, message: transMessage },
  } = useSelector((state) => state.messageBot);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [selected, setSelected] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(
    MESSAGE_STATUS_VIEW_LIST_LENGTHS[0].value,
  );
  const [order, setOrder] = useState('desc');
  const [sort, setSort] = useState('date');
  const [snack, setSnack] = useState({ open: false });

  useMount(() => {
    dispatch(
      getData({
        sort,
        desc: order === 'desc',
        skip: 0,
        limit: rowsPerPage,
      }),
    );
  });

  const onModalClick = (type, item) => {
    let items = item;
    if (!items) {
      items = selected.map((id) => list.find((li) => li.id === id));
    }
    dispatch(
      openModal({
        items,
        type,
      }),
    );
  };

  const onItemTransmitClick = () => {
    onModalClick(MODAL_TYPE_MESSAGE_TRANSMIT);
  };

  const onItemDeleteClick = () => {
    onModalClick(MODAL_TYPE_MESSAGE_DELETE);
  };

  const handleCheckClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);

    const { type, name } = event.target;
    if (type === 'button' && name) {
      onModalClick(name, [list.find((li) => li.id === id)]);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = contentItems.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleSortClick = (property) => () => {
    const isAsc = sort === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setSort(property);
  };

  const handleModalCancel = () => {
    setSelected([]);
    dispatch(closeModal());
  };

  const handleModalConfirm = (updateItems) => {
    const items = updateItems.map((id) => list.find((li) => li.id === id));
    if (modal.bDel) {
      dispatch(deleteMessage(items));
    } else {
      dispatch(transmitMessage(items));
    }
    handleModalCancel();
  };

  useUpdateEffect(() => {
    dispatch(
      getData({
        sort,
        desc: order === 'desc',
        skip: 0,
        limit: rowsPerPage,
      }),
    );
  }, [sort, order, rowsPerPage]);

  useUpdateEffect(() => {
    dispatch(
      getData({
        sort,
        desc: order === 'desc',
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      }),
    );
  }, [page]);

  useUpdateEffect(() => {
    if (delResult || transResult || sent) {
      dispatch(
        getData({
          sort,
          desc: order === 'desc',
          skip: page * rowsPerPage,
          limit: rowsPerPage,
        }),
      );
    }
  }, [delResult, transResult, sent]);

  useUpdateEffect(() => {
    setSnack({
      open: delResult || false,
      onClose: () => setSnack({ open: false }),
      message: delMessage,
      severity: delResult ? 'success' : 'error',
    });
  }, [delResult]);
  useUpdateEffect(() => {
    setSnack({
      open: transResult || false,
      onClose: () => setSnack({ open: false }),
      message: transMessage,
      severity: transResult ? 'success' : 'error',
    });
  }, [transResult]);
  useUpdateEffect(() => {
    setSnack({
      open: sent || false,
      onClose: () => setSnack({ open: false }),
      message: sendMessage,
      severity: sent ? 'success' : 'error',
    });
  }, [sent]);

  return (
    <>
      <Card sx={{ width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            m: 2,
          }}
        >
          <Typography variant="h5">메시지 내역 및 관리</Typography>
          {!loading && (
            <CardActions>
              {contentItems.length > 0 && open && (
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  disabled={selected.length === 0}
                  onClick={onItemTransmitClick}
                >
                  선택 재전송
                </Button>
              )}
              {contentItems.length > 0 && open && (
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  disabled={selected.length === 0}
                  onClick={onItemDeleteClick}
                >
                  선택 삭제
                </Button>
              )}
              <IconButton color="secondary" onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </CardActions>
          )}
        </Box>
        {open && (
          <CardContent>
            {contentItems.length === 0 && (error || '보낸 메시지가 없습니다.')}
            {contentItems.length > 0 && (
              <NewTable
                {...{
                  selectable: true,
                  name: 'message_status',
                  headerItems: MESSAGE_STATUS_HEADER_DATA,
                  contentItems,
                  lengthOptions: MESSAGE_STATUS_VIEW_LIST_LENGTHS,
                  total,
                  rowsPerPage,
                  page,
                  selected,
                  handleAllClick,
                  handleCheckClick,
                  handleChangePage,
                  handleChangeRowsPerPage,
                  handleSortClick,
                  order,
                  orderBy: sort,
                }}
              />
            )}
          </CardContent>
        )}
      </Card>
      {modal.open && typeof modal.bDel === 'boolean' && (
        <MessageModal
          {...{
            ...modal,
            onUpdate: handleModalConfirm,
            onCancel: handleModalCancel,
          }}
        />
      )}
      <Toast {...{ ...snack }} />
    </>
  );
};

export default MessageStatusContainer;
